import React, {Component} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import {tronLinkCheck, metaMaskCheck} from "../common/checks";
import {Button, Modal, Tooltip} from "antd";
import Emitter from "../eventBus.js";
import {setAccount, setChain, setBalance} from "../actions/app";
import {t} from "../utils/i18n";
import {enquireScreen} from "enquire-js";
import {login} from "../common/login";
import {getMetadata} from "../common/api"
import {addTokenToTronLink} from '../common/tronLink'
import Lottie from 'lottie-react-web'
import animation from '../jsons/ribbon.json'

let isMobile;

enquireScreen((b) => {
    isMobile = b;
});

class MessageModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            title: '',
            content: '',
            isInstalled: true,
            isLogin: true,
            source: null,
            type: null,
            data: null
        }
    }

    componentDidMount() {
        Emitter.on("showMessageModal", (params) => {
            this.showModal();
            if (params.source === 'login') {
                console.log('from login');
                this.setState({source: 'login'});
            }
            if (params.source === 'limit') {
                this.setState({source: 'limit'});
            }
            if (params.source === 'mint') {
                this.setState({source: 'mint'});
            }
            if (params.source === 'contract') {
                this.setState({source: 'contract', data: params.data});
            }
            if (params.source === 'upload' && params.type === 'success') {
                this.setState({source: 'upload', type: 'success'});
            }
            if (params.source === 'upload' && params.type === 'failed') {
                this.setState({source: 'upload', type: 'failed'});
            }
            if (params.source === 'download' && params.type === 'success') {
                this.setState({source: 'download', type: 'success'});
            }
            if (params.source === 'download' && params.type === 'failed') {
                this.setState({source: 'download', type: 'failed'});
            }
            if (params.source === 'onchain') {
                this.setState({source: 'onchain'});
            }
        });
    }

    componentWillUnmount() {
        Emitter.removeListener('showMessageModal', () => {
        });
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            visible: false,
            isInstalled: true,
            isLogin: true,
        });
    };

    connect = (wallet) => {
        wallet = 'tron';
        let isLogin, isInstalled, checkResult;
        if (wallet === 'tron') {
            checkResult = tronLinkCheck();
        }
        if (wallet === 'eth') {
            checkResult = metaMaskCheck();
        }
        isLogin = checkResult.isLogin;
        isInstalled = checkResult.isInstalled;
        if (!isInstalled) {
            this.setState({isInstalled: false});
            return;
        }
        if (!isLogin) {
            this.setState({isLogin: false});
            return;
        }
        if (isLogin) {
            this.setState({isLogin: true, isInstalled: true, visible: false});
            login(wallet, this.props);
        }

    }

    viewMetadata = async (contract, tokenID) => {
        if (contract) {
            let url = await getMetadata(contract.split('_')[2], tokenID);
            if (url.indexOf('https://gateway.btfs.io/btfs/') > -1) {
                window.open(url);
            } else {
                window.open("https://gateway.btfs.io/btfs/" + url);
            }
        }
    }

    render() {
        let {isLogin, isInstalled, source, type, data} = this.state;
        return (
            <div className="m-auto text-center">
                <Modal
                    visible={this.state.visible}
                    maskClosable={false}
                    centered={isMobile ? false : true}
                    onCancel={this.handleCancel}
                    footer={null}
                    wrapClassName={'message_modal_' + source}

                    style={!isMobile ? {width: '35rem', height: '35rem'} : {width: '150px', height: '150px'}}
                >

                    {source === 'login' &&
                    <div className="h-full flex flex-col justify-between items-center ml-auto mr-auto">
                        <div className="m-2"><img alt='logo2' className='logo2'
                                                  src={require('../images/logo2.png').default}/></div>
                        <div className="m-2 modal_title"><strong>{t('connect_wallet')}</strong></div>
                        <div className="modal_description">{t('connect_wallet_description')}</div>
                        <div className="m-2">
                            <Button className='connect_button' onClick={this.connect}>
                                <img alt='logo3' className='logo3 inline float-left'
                                     src={require('../images/logo3.png').default}/>
                                {t('connect_tronlink')}
                            </Button>
                        </div>
                        <div className="m-2 no_install">
                            {t('no_tronlink')} &nbsp;
                            <a target='_blank'
                               rel="noreferrer"
                               href="https://chrome.google.com/webstore/detail/tronlink/ibnejdfjmmkpcnlpebklmnkoeoihofec">
                                {t('to_install')} >>
                            </a>
                        </div>
                        {!isLogin && <div className='w-full login_warning absolute bottom-0'>{t('login_first')}</div>}
                        {!isInstalled &&
                        <div className='w-full login_warning absolute bottom-0'>{t('install_first')}</div>}
                    </div>
                    }

                    {source === 'mint' &&
                    <div className="h-full flex flex-col justify-between items-center ml-auto mr-auto">
                        <div className=" modal_title">{t('coming_soon')}</div>
                        <div className=" modal_description">
                            {t('mint_description')}
                        </div>
                        <div><img alt='loading' className='loading' src={require('../images/loading.svg').default}/>
                        </div>
                    </div>
                    }

                    {(source === 'upload' || source === 'download') &&
                    <div className="h-full flex flex-col justify-center items-center ml-auto mr-auto">
                        <div className="m-2"><strong>{source} {type}</strong></div>
                    </div>
                    }

                    {source === 'limit' &&
                    <div className="h-full flex flex-col justify-between items-center ml-auto mr-auto">
                        <div className=" modal_title">{t('limit_exceed')}</div>
                        <div className=" modal_description">
                            {t('limit_description')}
                        </div>
                        <div className="modal_title">btfs-developer@bittorrent.com</div>
                    </div>
                    }

                    {source === 'contract' &&
                    <div className="h-full flex flex-col justify-between items-center ml-auto mr-auto">
                        <div className=" modal_title">{t('related_contract')}</div>
                        <div className='overflow-auto w-full modal_content mt-8 mb-8'>
                            {
                                data.map((item, id) => {

                                    return <div className="w-full flex justify-between items-center mt-2 mb-8" key={id}>
                                        <div className='flex items-center overflow-auto'>
                                            <img className='NFT_logo' src={require('../images/NFT-file-logo.png').default}/>
                                            <div className='ml-8'>
                                                <div className='flex items-center mb_b8px'>
                                                    <strong># {item['token_id']}</strong>

                                                    <button className='ml-4' onClick={() => {
                                                        this.viewMetadata(item.contract, item['token_id'])
                                                    }}>
                                                        <img className='meta_button'
                                                             src={require('../images/metadata.png').default}/>
                                                    </button>
                                                </div>
                                                <div>
                                                    BTFS NFT collection
                                                    @ {item.contract && item.contract.split('_')[0]} {item.contract && item.contract.split('_')[1]}
                                                    <Tooltip
                                                        title={t('add_to_link')}>
                                                        <img className='add_link' onClick={() => {
                                                            addTokenToTronLink({address: item.contract && item.contract.split('_')[2], type: item.contract && item.contract.split('_')[1]})
                                                        }}
                                                        src={require('../images/add-to-tron-link.png').default} />
                                                    </Tooltip>
                                                </div>
                                                <div>{item.contract && item.contract.split('_')[2] + '/' + item['token_id']}</div>
                                                
                                            </div>
                                        </div>
                                        <Button className='view_button' type='primary' onClick={() => {
                                            if (item.contract && item.contract.split('_')[0] === 'TRON') {
                                                window.open('https://tronscan.org/#/token721/' + item.contract.split('_')[2] + '/' + item['token_id'])
                                            }
                                        }}>{t('view')}</Button>
                                    </div>
                                })
                            }

                        </div>
                        <div className=" modal_footer">
                            {t('contract_future')}
                        </div>
                    </div>
                    }

                    {source === 'onchain' &&
                    <div className="h-full flex flex-col justify-between items-center ml-auto mr-auto text-center relative chain_content">
                        <div className="lottie_box absolute">
                            <Lottie
                                options={{
                                    animationData: animation
                                }}
                            />
                        </div>
                        <img className='absolute modal_top_img' src={require('../images/NFT-file-true-2.png').default}/>
                        <div>
                            <div className='modal_title'>{t('mint_successful')}</div>
                            <div className="modal_description">{t('NFT_on_chain')}</div>
                        </div>
                        <Button type="primary" className='ok_button'
                            onClick={this.handleCancel}>
                            {t('ok')}
                        </Button>
                    </div>
                    }

                </Modal>
            </div>);
    }
}

function mapStateToProps(state) {
    return {
        currentAccount: state.app.currentAccount,
    }
}

const mapDispatchToProps = {
    setAccount,
    setChain,
    setBalance
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(MessageModal));
